const formsAtIterableComFormSubmissionValidationErrorSubject = require("./formsAtIterableComFormSubmissionValidationErrorSubject");
const formsAtIterableComFormSubmissionMessage = require("./formsAtIterableComFormSubmissionMessage");
const sendEmailToFormsAtIterableCom = require("./sendEmailToFormsAtIterableCom");

/**
 * @param form {string}
 * @param email {string}
 * @param marketoFormId {string}
 * @param formData {Object}
 * @return {Promise<void>}
 */
module.exports = async function sendFormSubmissionValidationErrorEmailToFormsAtIterableCom(form, email, marketoFormId, formData) {
    const subject = formsAtIterableComFormSubmissionValidationErrorSubject(form, email, marketoFormId);
    const message = formsAtIterableComFormSubmissionMessage(formData);
    void sendEmailToFormsAtIterableCom(subject, message);
}